<template>
  <v-dialog class="pb-3" v-model="showDialog" v-bind="$attrs">
    <v-card>
      <v-list>
        <v-list-item>
          <v-list-item-avatar class="primary">
            <v-img :src="icone" />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title class="text-h6 font-weight-black">
              {{titulo}}
            </v-list-item-title>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon small @click="onCloseClick" title="Fechar">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <v-divider />
      <v-card-text class="mt-2">
        <slot></slot>
      </v-card-text>
    </v-card>
  </v-dialog>
  
</template>

<script>
import Vue from "vue"
export default Vue.component("tj-info-dialog", {
  props: {
    value: Boolean,
    icone: String,
    titulo: String,
  },

  model: {
    prop: "value",
    event: "update"
  },

  computed: {
    showDialog: {
      get(){
        return this.value
      },
      set(v){
        if(v !== this.value) this.$emit("update", v)
      }
    }
  },

  methods: {
    onCloseClick(){
      this.showDialog = false
    }
  }
})
</script>